<template>
  <div id="example">
    <h3 style="text-align:center">Rating example</h3>
    <div class="container">
      <div class="sub-title">默认</div>
      <Rating/>
    </div>
    <div class="container">
      <div class="sub-title">基础使用</div>
      <Rating v-model="score1" />
    </div>

    <div class="container">
      <div class="sub-title">自定义展示个数</div>
      <Rating v-model="score2" :count="6" />
    </div>

    <div class="container">
      <div class="sub-title">自定义icon大小</div>
      <Rating v-model="score3" size="60" />
    </div>

    <div class="container">
      <div class="sub-title">自定义icon颜色</div>
      <Rating v-model="score4" activeColor="#d41515" inactiveColor="#c96d6d" />
    </div>

    <div class="container">
      <div class="sub-title">展示小数评分</div>
      <Rating v-model="score5" />
    </div>

    <div class="container">
      <div class="sub-title">纯展示模式</div>
      <Rating v-model="score6" disabled />
    </div>

    <div class="container">
      <div class="sub-title">自定义icon</div>
      <symbol id="my-icon" viewBox="0 0 1024 1024">
        <path
          d="M501.930667 204.8c32.5632 0 61.064533 16.2816 78.677333 40.686933 2.730667 4.096 6.826667 5.461333 10.8544 5.461334 1.365333 0 4.096 0 5.461333-1.365334 8.123733-4.096 14.916267-5.461333 23.04-5.461333 8.157867 0 14.916267 1.365333 21.7088 5.461333 29.866667 16.2816 31.197867 67.822933 5.461334 112.605867-2.730667 5.4272-6.826667 10.8544-10.888534 16.2816-5.4272 6.792533-4.096 16.2816 4.096 20.343467a295.867733 295.867733 0 0 1 161.450667 264.567466c0 58.368-19.012267 112.64-50.210133 157.3888a80.7936 80.7936 0 0 1-59.221334 32.3584l-5.905066 0.2048H320.136533c-25.8048 0-50.210133-12.219733-65.1264-32.5632A275.012267 275.012267 0 0 1 204.8 663.415467a300.8512 300.8512 0 0 1 160.085333-265.966934c8.157867-4.061867 9.5232-13.550933 4.096-20.343466-4.096-4.096-6.826667-10.8544-10.8544-16.2816-25.8048-44.782933-23.074133-96.324267 5.4272-112.605867 6.7584-4.096 13.550933-5.4272 21.7088-5.4272 6.7584 0 14.916267 1.365333 21.7088 6.792533 1.365333 1.365333 4.061867 1.365333 5.4272 1.365334 4.061867 0 8.123733-1.365333 10.8544-5.461334A96.9728 96.9728 0 0 1 501.930667 204.8z m0 34.133333c-20.309333 0-39.0144 9.9328-50.2784 25.4976a46.08 46.08 0 0 1-39.253334 20.616534 46.421333 46.421333 0 0 1-8.328533-0.6144 37.819733 37.819733 0 0 1-17.271467-7.236267l-1.160533-1.024c0.648533 0.580267 0.8192 0.682667 0.341333 0.750933h-0.7168c-2.8672 0-3.447467 0.136533-4.778666 0.9216-8.192 4.676267-10.0352 32.119467 4.334933 60.6208l2.594133 4.676267 1.877334 2.8672 4.369066 7.406933-0.546133-0.443733 2.491733 2.798933c17.749333 22.186667 13.1072 54.442667-10.410666 69.393067l-4.334934 2.4576A266.683733 266.683733 0 0 0 238.933333 663.381333c0 49.322667 15.598933 97.006933 43.588267 137.216 7.509333 10.24 19.5584 16.964267 32.6656 18.3296l4.949333 0.273067H686.421333c14.984533 0 29.149867-7.099733 37.102934-17.954133a240.7424 240.7424 0 0 0 44.100266-137.864534c0-100.1472-55.808-190.020267-142.609066-234.018133a46.865067 46.865067 0 0 1-18.909867-67.4816l7.338667-10.103467c1.160533-1.672533 2.048-3.072 2.8672-4.437333l1.194666-2.184533c17.783467-30.9248 16.554667-60.8256 6.587734-66.321067-0.7168-0.4096-1.297067-0.546133-4.164267-0.546133a14.097067 14.097067 0 0 0-5.802667 0.887466l-1.2288 0.750934c-2.798933 1.604267-5.700267 2.730667-8.635733 3.515733l-4.5056 0.989867a46.421333 46.421333 0 0 1-8.328533 0.6144c-15.291733 0-29.934933-6.621867-38.5024-19.5584A62.805333 62.805333 0 0 0 501.930667 238.933333z"
          p-id="816"
        ></path>
        <path
          d="M486.058667 740.215467l0.170666 6.007466c0 22.7328 34.133333 22.7328 34.133334 0a106.837333 106.837333 0 0 1 106.461866-106.496c22.7328 0 22.7328-34.133333 0-34.133333l-6.007466-0.136533A106.9056 106.9056 0 0 1 520.533333 505.173333l-0.170666-6.007466c0-21.504-30.446933-22.698667-33.826134-3.584l-0.341333 3.584a106.837333 106.837333 0 0 1-100.420267 106.2912l-6.007466 0.170666c-21.504 0-22.698667 30.446933-3.584 33.792l3.584 0.341334a106.837333 106.837333 0 0 1 106.2912 100.4544z m17.2032-174.1824l2.218666 3.959466c12.219733 20.821333 29.696 38.263467 50.517334 50.517334l3.8912 2.1504-3.8912 2.218666c-20.821333 12.219733-38.2976 29.696-50.517334 50.517334l-2.218666 3.925333-2.1504-3.959467a142.1312 142.1312 0 0 0-50.517334-50.517333l-3.925333-2.184533 3.925333-2.184534a142.1312 142.1312 0 0 0 50.517334-50.517333l2.1504-3.925333z"
          p-id="817"
        ></path>
      </symbol>
      <Rating
        v-model="score7"
        iconid="my-icon"
      />
    </div>

    <div class="container">
      <div class="sub-title">自定义图片</div>
      <Rating v-model="score8" :activeImage="customImg.active" :inactiveImage="customImg.default"/>
    </div>

    <div class="container">
      <div class="sub-title">图片样式自定义</div>
      <Rating v-model="score9" :activeImage="customImg.active" :inactiveImage="customImg.default" :customImgStyle="imgstyle"/>
    </div>

    <div class="container">
      <div class="sub-title">设置分数的回调事件 after-rate</div>
      <Rating v-model="score10" @after-rate="onAfterRate" />
    </div>
  </div>
</template>

<script>
import Rating from '../src/components/Rating.vue'
export default {
  name: 'example',
  components: {
    Rating,
  },
  data() {
    return {
      score1: 2,
      score2: 4,
      score3: 2,
      score4: 4,
      score5: 2.6,
      score6: 4,
      score7: 3,
      score8: 3,
      score9: 4,
      score10: 0
    }
  },
  computed: {
    customImg() {
      return {
        default: require('../src/assets/close_btn.png'),
        active: require('../src/assets/close_btn_a.png'),
      }
    },
    imgstyle() {
      return {
        width: '30px',
        height: '30px',
        margin: '0 10px',
      }
    },
  },
  methods: {
    onAfterRate(score) {
      alert(score)
    },
  },
}
</script>

<style lang="scss">
#example {
  text-align: left;
  padding-left: 30px;
  .container {
    margin-bottom: 20px;
    .sub-title {
      text-indent: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
